import React, { useState, useRef } from 'react';
import * as _ from 'lodash';

// modals
import CommonModal from '../modals/common/Modal';
import { Information, Confirmation } from '../modals/common';
import { DownloadFileErrorDialog } from '../modals/DownloadFileErrorDialog';
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';
import { CcusErrorDialog } from '../modals/CcusErrorDialog';

//utilities
import { messageUtility } from '../../utilities/messageUtility';
import { useFetchDataWithToken } from '../../utilities/useFetchData';
import dialogLoader from '../../utilities/dialogLoader';
import AuthProvider from '../../utilities/authProvider';

//service
import SessionStorageService from '../../services/utilities/SessionStorageService';
import DirectApiSettingsApi from '../../services/DirectApiSettings';

import CopyToClipBordArea from '../CopyToClipBordArea';

export default function DirectRegisterBuildeeBotGuideModal({
  visible,
  setVisible,
  onClose = () => {},
}) {
  const fieldId = SessionStorageService.getFieldId();
  const {
    data: buildeeBotEmailResponse,
    isInitLoded: isBuildeeBotEmailLoaded,
    isError: isBuildeeBotEmailError,
  } = useFetchDataWithToken(
    DirectApiSettingsApi.buildee_bot_email.fetch_options(fieldId),
    DirectApiSettingsApi.buildee_bot_email.fetch_default_response(),
    false,
    true,
    visible
  );
  const buildee_bot_email = _.get(
    buildeeBotEmailResponse,
    'data.entities.buildee_bot_email',
    ''
  );
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const [
    isShowDownloadFileErrorModal,
    SetIsShowDownloadFileErrorModal,
  ] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(true);

  const onSubmit = () => {
    setVisible(false);
    setIsShowConfirmModal(true);
  };

  return (
    <React.Fragment>
      {!isBuildeeBotEmailError ? (
        <React.Fragment>
          <CommonModal
            visible={visible}
            modalClassName={'DirectDescriptionModal--BuildeeBotGuide'}
          >
            <div className='dialog dialog--modal'>
              <div className='dialog__header'>
                <span className='dialog__title'>
                  {messageUtility.getMessage('I-001-552')}
                </span>
              </div>
              <div className='dialog__body'>
                <div className='dialog__text'>
                  {messageUtility.getMessage('I-001-553')}
                </div>
                <div className='dialog__text dialog__text--large'>
                  <div className='dialog__email'>
                    {messageUtility.getMessage('I-001-554')}
                    {isBuildeeBotEmailLoaded && (
                      <CopyToClipBordArea 
                        copyText={buildee_bot_email}
                      >
                        {buildee_bot_email}
                      </CopyToClipBordArea>

                    )}
                  </div>
                  {messageUtility.getMessage('I-001-555')}
                </div>
                <div className='dialog__text'>
                  {messageUtility.getMessage('I-001-556')}
                </div>
              </div>
              <div className='dialog__footer dialog__footer--horizontal'>
                <button className='btn-fixedsize--sub' onClick={onClose}>
                  {messageUtility.getMessage('I-000-017')}
                </button>
                <button className='btn-fixedsize' onClick={onSubmit}>
                  {messageUtility.getMessage('I-000-248')}
                </button>
              </div>
            </div>
          </CommonModal>
          <DirectRegisterBuildeeBotConfirmModal
            visible={isShowConfirmModal}
            setVisible={setIsShowConfirmModal}
            onBack={() => {
              setVisible(true);
            }}
            onClose={onClose}
          />
          <DownloadFileErrorDialog
            visible={isShowDownloadFileErrorModal}
            onClose={() => {
              SetIsShowDownloadFileErrorModal(false);
            }}
          />
        </React.Fragment>
      ) : (
        <DirectCommunicationErrorModal
          visible={isShowErrorModal}
          setVisible={setIsShowErrorModal}
          closeAction={() => {
            setVisible(false);
            onClose();
          }}
        />
      )}
    </React.Fragment>
  );
}

function DirectRegisterBuildeeBotConfirmModal({
  visible,
  setVisible,
  onBack,
  onClose,
}) {
  const [isShowSuccessModal, setIsShowSuccessModal] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const isSending = useRef(false);
  const onConfirm = async () => {
    if (isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const fieldId = SessionStorageService.getFieldId();
      await DirectApiSettingsApi.bulildee_bot_invitation_approval(fieldId, false);
      setVisible(false);
      setIsShowSuccessModal(true);
    // API実行の結果が400・404・500エラーになった場合に独自のエラーメッセージを表示したいため、独自のエラー処理を行う。
    } catch (e) {
      setVisible(false);
      switch (e.status) {
        case 400: {
          setErrorMessage(_.get(e, 'data.message'));
          setIsShowErrorModal(true);
          return;
        }
        case 401: {
          // エラーメッセージをダイアログに出力後、ログアウト処理を実行
          dialogLoader.show(
            CcusErrorDialog,
            {
              callback: {
                done: () => {
                  AuthProvider.instance.logout();
                },
              },
              message:
                e.data.message || messageUtility.getMessage('E-000-036'),
            },
            null
          );
          return false;
        }
        case 403: {
          setIsShowErrorModal(true);
          return;
        }
        case 404: {
          if (_.get(e, 'data.message').includes('direct')) {
            setErrorMessage(_.get(e, 'data.message'));
            setIsShowErrorModal(true);
            return;
          } else {
            window.location.replace('/error-permission');
            return false;
          }
        }
        case 409: {
          setIsShowErrorModal(true);
          return;
        }
        case 422: {
          setIsShowErrorModal(true);
          return;
        }
        case 500: {
          setErrorMessage(_.get(e, 'data.message'));
          setIsShowErrorModal(true);
          return;
        }
        case 503: {
          window.location.replace('/');
          return false;
        }
        default: {
          console.error(
            'request.js requestWithToken',
            'ネットワークエラーです',
            errorMessage
          );
  
          window.location.replace('/error-500');
          return false;
        }
      }
    } finally {
      isSending.current = false;
    }
  };
  return (
    <React.Fragment>
      <Confirmation
        visible={visible}
        rootClassName={'DirectDescriptionModal--RegisterBuildeeBotConfirm'}
        title={messageUtility.getMessage('I-001-557')}
        message={messageUtility.getMessage('I-001-558')}
        confirmButtonText={messageUtility.getMessage('I-001-581')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={onConfirm}
        onCancel={() => {
          setVisible(false);
          onBack();
        }}
        tabFocus={true}
      />
      <DirectRegisterBuildeeBotSuccessModal
        visible={isShowSuccessModal}
        setVisible={setIsShowSuccessModal}
        onClose={onClose}
      />
      <DirectCommunicationErrorModal
        visible={isShowErrorModal}
        setVisible={setIsShowErrorModal}
        errorMessage={errorMessage}
        closeAction={onClose}
      />
    </React.Fragment>
  );
}

function DirectRegisterBuildeeBotSuccessModal({
  visible,
  setVisible,
  onClose,
}) {
  return (
    <React.Fragment>
      <Information
        visible={visible}
        title={messageUtility.getMessage('I-001-559')}
        message={messageUtility.getMessage('I-001-560')}
        buttonText={messageUtility.getMessage('I-000-017')}
        onClose={() => {
          setVisible(false);
          onClose();
        }}
        rootClassName={'DirectDescriptionModal--RegisterBuildeeBotSuccess'}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectRegisterBuildeeBotGuideModal.jsx